export default __webpack_public_path__ + "static/media/logo.c9538d7f.svg";